import {observer} from "mobx-react";
import {useStore} from "../../../../../../../hooks";
import {
  CloseButtonWrapper,
  ModalActionsWrapper,
  ModalBox,
  ModalContentWrapper, ModalWrapper
} from "../../../../../../../elements/v2/modals/Modals.styled";
import {IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";
import {Title} from "../../../../../../../elements/v2/modals/ConfirmationModal.styled";
import {MarketingErrorMessages} from "../../../../../../../utils/enums";
import {RoundedButton} from "../../../../../../../elements";
import React from "react";

export const AgentSelectionConfirmationModal = observer(() => {
  const { marketingStore } = useStore();
  const { modal } = marketingStore;
  
  return (
    <ModalWrapper $isOpen={modal.agentSelection}>
      <ModalBox width="500px" height="305px">
        <CloseButtonWrapper>
          <IconButton width="16px" height="16px" onClick={() => modal.onCancel("agentSelection")}>
            <Close />
          </IconButton>
        </CloseButtonWrapper>
        <ModalContentWrapper>
          <Title>{MarketingErrorMessages.PREVENT_DRAFT_WITHOUT_AGENT.title}</Title>
          <p>{MarketingErrorMessages.PREVENT_DRAFT_WITHOUT_AGENT.message}</p>
        </ModalContentWrapper>
        <ModalActionsWrapper>
          <RoundedButton onClick={() => {
            modal.onConfirm("agentSelection")
          }} kind={"primary"}>Save as Draft</RoundedButton>
          <RoundedButton onClick={() => modal.onCancel("agentSelection")} kind={"blue"}>Assign Agent</RoundedButton>
        </ModalActionsWrapper>
      </ModalBox>
    </ModalWrapper>
  );
});
